import { CommonModule } from '@angular/common';
import { Attribute, Component } from '@angular/core';

@Component({
  selector: 'skeleton-loading',
  imports: [CommonModule],
  templateUrl: './skeleton-loading.component.html',
  styleUrl: './skeleton-loading.component.scss',
})
export class SkeletonLoadingComponent {
  readonly hostClasses: string[];

  constructor(@Attribute('class') hostClass: string | null) {
    this.hostClasses = (hostClass ?? '').split(/\s+/).filter(Boolean);
  }
}
